import React, {Component} from 'react';
import {Modal, Button}  from 'react-bootstrap'
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";
import {convertLocalToZoneTime, SiteTimeNow} from '../timeFunctions/TimeZone';

import './report-header.css'

export default class PeriodPicker extends Component {
  constructor(props) {
    super(props);

    const until = this.untilFromProps()
    this.state = {
      startDate: this.startFromProps(),
      endDate: until,
      errMsg: null,
    };
    this.show = props.show;
    this.handleChangeStart = this.handleChangeStart.bind(this);
    this.handleChangeEnd = this.handleChangeEnd.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.validate = this.validate.bind(this);
  }
  componentDidUpdate(prevProps) {
    if (prevProps?.period[0].getTime() !== this.props?.period[0].getTime() || 
        prevProps?.period[1].getTime() !== this.props?.period[1].getTime()) {
          const until = this.untilFromProps(this.props)
          const from = this.startFromProps(this.props)
          this.setState({startDate: from, endDate: until} )
    }
  }
  untilFromProps () {
    const dcap_tz = sessionStorage.getItem ('site-tz');
    return this.props?.period[1] ?? SiteTimeNow(dcap_tz)
  }
  startFromProps(until) {
    return this.props?.period[0] ?? convertLocalToZoneTime(until.getTime() - 24 * 3600 * 1000)
  }
  handleChangeStart(date) {
    this.setState({
      startDate: date
    });
  }
    
  handleChangeEnd(date) {
    this.setState({
      endDate: date
    });
  }
    
  handleClose() {
    this.show = false;
    this.props.hide();
  }
  validate() {
    var msg = null;
    if (this.state.startDate >= this.state.endDate)
      msg = "From must be earlier than To date";

    this.setState ({errMsg: msg})
    if (msg === null) {
      if (this.props.start)
        this.props.start(this.state.startDate); //deprecated
      this.props.onChange (this.state.startDate, this.state.endDate);
      this.handleClose();
    }
    if (this.props.onChange)
      this.props.onChange(this.state.startDate, this.state.endDate);
  }
  datePicker (select, start, end, persist) {
    return (
      <DatePicker selected={select}
        selectsStart
        startDate={start}
        endDate={end}
        onChange={persist}
        timeFormat="HH:mm"
        timeIntervals={60}
        showTimeSelect
        dateFormat="MMMM d, yyyy HH:mm"
        className="date-picker"
      />
    );
  }

  render() {
    return(
      <Modal show={this.props.show} onHide={this.handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Select Period</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        From:&nbsp; 
        {this.datePicker(this.state.startDate, this.state.startDate, this.state.endDate, this.handleChangeStart)}
        &nbsp;To:&nbsp;
        {this.datePicker(this.state.endDate, this.state.startDate, this.state.endDate, this.handleChangeEnd)}
      </Modal.Body>
      <Modal.Footer>
        <div className="modal-error">{this.state.errMsg}</div>
        <Button variant="secondary" onClick={this.handleClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={this.validate}>
          Ok
        </Button>
      </Modal.Footer>
    </Modal>
    )
  }
}  